module.exports = __webpack_public_path__ + "static/media/Sara_canvas_2.3da1e57f.png";